/* Make the WHOLE pay-later row clickable, not just the (i).

   Why a separate file rather than a dozen lines inside spb.js: spb.js is
   50KB and Shopify only writes whole files, so every edit there means
   resending the lot. This behaviour is self-contained - it needs nothing
   from spb.js's closure - so it costs 2KB to change instead of 50KB.

   HOW IT WORKS
   The (i) button carries data-paylater / data-context / data-amount, and
   shaped-pdp.js has a DELEGATED handler on [data-paylater] that opens the
   theme's pay-later sheet. The chips just forward their click to that
   button. One code path, and crucially the amount still comes off the
   (i)'s data-amount - which spb.js's draw() rewrites whenever the tier
   changes. Copying data-amount onto the chips instead would freeze them
   at the Buy-1 price and quietly show the wrong figure on a bundle.

   The chips are <span>, so they need role/tabindex/keydown to be
   reachable without a mouse. They are NOT wrapped in a <button> because
   the (i) inside the row is already one, and nesting buttons is invalid.

   Runs on its own: no Liquid, idempotent via data-spb-payrow, and
   re-runs on shopify:section:load for the theme editor. */
(function(){

  function wire(root){
    var btn = root.querySelector('[data-spb-payinfo]');
    if (!btn) return;
    var chips = root.querySelectorAll('.spb-chip');
    Array.prototype.forEach.call(chips, function(chip){
      if (chip.getAttribute('data-spb-payrow')) return;
      chip.setAttribute('data-spb-payrow', '1');
      chip.style.cursor = 'pointer';
      chip.setAttribute('role', 'button');
      chip.setAttribute('tabindex', '0');
      chip.setAttribute('aria-label', 'How pay later works');
      chip.addEventListener('click', function(){ btn.click(); });
      chip.addEventListener('keydown', function(e){
        if (e.key === 'Enter' || e.key === ' '){ e.preventDefault(); btn.click(); }
      });
    });
  }

  function init(){
    var blocks = document.querySelectorAll('.spb');
    Array.prototype.forEach.call(blocks, wire);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  setTimeout(init, 800);
})();